export default __webpack_public_path__ + "static/media/modal_1_wood_mobile.394c4351.svg";